import { render, staticRenderFns } from "./MaterialRequestFilters.vue?vue&type=template&id=450bfcd7"
import script from "./MaterialRequestFilters.vue?vue&type=script&lang=js"
export * from "./MaterialRequestFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports